export default {
  items: [],
  lots: []
}
